


















import { Component, Prop, Vue } from "vue-property-decorator";

import { FileHelper } from '@/helper/fileHelper';
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {
  }
})

export default class changeNameModal extends Vue {
    @Prop() private name! : string;
    @Prop() private isFolder! : boolean;
    // 絵文字を使えなくするかどうか？
    @Prop({default: false}) private isEmojiRestricted! : boolean;

    // 絵文字、サロゲートペア
    // https://ichi.pro/javascript-no-emoji-271114725718523
    static readonly emojiPattern = "(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])"
    changeName = "";
    extension = "";
    isCanSubmit = false;
    oldName = "";

    // 絵文字、サロゲートペアのチェック
    containsEmoji(text : string)
    {
        let emojiReg = new RegExp(changeNameModal.emojiPattern, 'g');
        return emojiReg.test(text);
    }
    replaceEmoji(text : string)
    {
        let emojiReg = new RegExp(changeNameModal.emojiPattern, 'g');
        return text.replace(emojiReg, '?');
    }

    mounted(){
        if(this.isFolder){
            this.changeName = this.name;
        }
        else{
            // 拡張子とファイル名を分離
            if(this.name.split(".").length > 1){
                this.extension = "." + this.name.split(".").slice(-1)[0];
            }
            if(this.extension == ""){
                this.changeName = this.name;
            }
            else{
                this.changeName = FileHelper.getFilenameWithoutExtension(this.name);
            }
        }
        this.oldName = this.changeName;
        (<HTMLInputElement>this.$refs.inputChangeName).focus();
    }

    setCanSubmit(){
        this.isCanSubmit = true;
    }

    keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.changeName == ""){ return; }
        this.clickchangeNameButton();
    }

    clickchangeNameButton(){
        if(this.isEmojiRestricted)
        {
            // 機種依存文字のチェック
            DebugHelper.trace("機種依存文字のチェック!");
            let newName = this.changeName;
            if(this.containsEmoji(newName))
            {
                DebugHelper.trace("環境依存文字を差し替えます");
                newName = this.replaceEmoji(newName);
                this.changeName = newName;
            }
        }
        // 同名のままならば処理しない
        // if(this.oldName != this.changeName){
            this.$emit('changeNameData', this.changeName + this.extension);
        // }
        this.$emit('close');
    }

    get inputCheck(){
        if(this.changeName){
            if(this.changeName == ""){
                return false;
            }else if(!this.changeName.match(/\S/g)){
                return false;
            }else{
                return true;
            }
        }else{
            return false;
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
    private get borderStyle(){
        return {
            "border-bottom" : "solid 1px " + this.userConfigColor
        };
    }
}
